import React from 'react';
import './ImageList.scss';
import { LANGUAGE_CODES } from '../constants.js';

const ImageList = ({ rows, onShareClicked, onDeleteClicked, languageCode, locations, locationId }) => {
    function open(url) {
        window.open(url, '_blank');
    }

    function getLocationName(areaId) {
        const location = locations.find(loc => loc.id === Number(areaId));
        if (!location) return '';
        return languageCode === LANGUAGE_CODES.KO ? location.name_ko : location.name_en;
    }

    return (
        <div className="list_container">
            {rows.map((item) => (
                <div className="image_list" key={item.id}>
                    <div className="list_item">
                        <div 
                            className="thumbnail" 
                            onClick={() => open(`https://www.youtube.com/watch?v=` + item.videoId)}
                            data-testid="thumbnail-link"
                        >
                            <img className="img" src={item.thumbnailUrl} alt={rows.title} />
                        </div>
                        <div className="title">{item.title}</div>
                        <div className="name">
                            {getLocationName(item.areaId)}
                        </div>
                        <div className="channelId">{item.channelId}</div>
                        <div className="buttons">
                            <button onClick={async () => {
                                try {
                                    await onShareClicked(locationId, "Youtube", item.title, "", `https://www.youtube.com/watch?v=` + item.videoId);
                                    alert("News added successfully to the queue");
                                } catch (error) {
                                    console.error('Error sharing news:', error);
                                    alert("An error occurred. Please check if the news was added successfully.");
                                }
                            }}>Share</button>
                            <button onClick={() => onDeleteClicked(item.id)}>Delete</button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ImageList;